export const UPDATE_PROFILE_ACTION_TYPES =
  'UPDATE_PROFILE_ACTION_TYPES' as const;
